import { isAdminSubDomain, isBQDomain } from '../helpers/utils.helper';

export const MIN_MANAGER_PWD_CHAR_REQUIRED = 14;

export const LOGO = isAdminSubDomain
  ? { src: '/assets/trycycle-logo.png', alt: 'TryCycle Data Systems logo' }
  : isBQDomain
    ? { src: '/assets/bq-logo.png', alt: "Buddy's Quest logo" }
    : { src: '/assets/talkingstick_logo_full_1200.png', alt: 'Talking Stick logo' };

export const SMALL_LOGO = isAdminSubDomain
  ? { src: '/assets/trycycle-icon.png', alt: 'TryCycle Data Systems logo' }
  : isBQDomain
    ? { src: '/assets/bq-logo.png', alt: "Buddy's Quest logo" }
    : { src: '/assets/ts-logo-sm.png', alt: 'Talking Stick logo' };
